import { useState } from "react";
import { useApi, Status } from "./useApi";

export const DocumentosView = ({ onDoc }) => {
  const [q, setQ] = useState("");
  const [tipo, setTipo] = useState("");
  const [deporte, setDeporte] = useState("");
  const { data: f } = useApi("/filtros");
  const { data, error } = useApi("/documentos", { q, tipo, deporte });
  return (
    <div data-testid="documentos-view">
      <div className="fgrid">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar en el texto de todos los documentos…" aria-label="Buscar en documentos" data-testid="documentos-search-input" />
        <select value={tipo} onChange={(e) => setTipo(e.target.value)} aria-label="Tipo" data-testid="documentos-tipo-select">
          <option value="">Todos los tipos</option>
          {(f?.tipos || []).map((d) => <option key={d}>{d}</option>)}
        </select>
        <select value={deporte} onChange={(e) => setDeporte(e.target.value)} aria-label="Deporte" data-testid="documentos-deporte-select">
          <option value="">Todos los deportes</option>
          {(f?.docDeportes || []).map((d) => <option key={d}>{d}</option>)}
        </select>
      </div>
      <Status data={data} error={error} />
      {data && (
        <>
          <p className="note" data-testid="documentos-count">{data.length} documentos</p>
          <div className="wrapx">
            <table className="tbl" data-testid="documentos-table">
              <thead><tr><th>Fecha</th><th>Documento</th><th>Tipo</th><th>Deporte</th><th>Periodo</th><th></th></tr></thead>
              <tbody>
                {data.map((d) => (
                  <tr key={d.id} className="clk" onClick={() => onDoc(d.id)} data-testid={`documento-row-${d.id}`}>
                    <td style={{ whiteSpace: "nowrap" }}>{d.fecha}</td>
                    <td>{d.titulo}{d.extracto && <div className="ext">{d.extracto}</div>}</td>
                    <td>{d.tipo}</td><td>{d.deporte}</td><td>{d.periodo}</td>
                    <td>{d.url && <a href={d.url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} style={{ color: "var(--sol-l)", whiteSpace: "nowrap" }} data-testid={`documento-drive-${d.id}`}>Abrir en Drive</a>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};
